module.exports = __webpack_public_path__ + "static/media/ravle.f8c83824.svg";